module.exports = __webpack_public_path__ + "img/Apoptosis-PDAC_GSE202740.8eba3353.png";